import { asObject, asString, uncleaner } from 'cleaners'









// Login data decrypted into memory.


































































export const asEdgeWalletInfo = asObject({
  id: asString,
  keys: (raw) => raw,
  type: asString
})

export const wasEdgeWalletInfo = uncleaner(asEdgeWalletInfo)
